itsoftApp.createModule("videoAutoplay", function () {
    const module = this;

    const videoInit = function (container) {
        const video = container.querySelector(".js-video-item");
        const onVideoPlay = function () {
            video.play();
        };

        if (video) {
            video.playbackRate = 0.5;
            video.loop = true;
            video.setAttribute("controlslist", "nodownload");

            itsoftApp.modules.pageLoad.addEvent(function () {
                setTimeout(function () {
                    onVideoPlay();
                }, 300)
            });
        }
    }

    module.init = videoInit;
});